import iconMap from './iconMap';

export default function Icon({ name, ...props }) {
  const IconComponent = iconMap[name];

  if (!IconComponent) return null;

  return <div className="icon-container"><IconComponent {...props} /></div>;
}
